// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0f1cf8aa","239":"46fa55cb","667":"aec583b4"}[chunkId] + ".chunk.js";
};